import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { MailOutlined } from "@ant-design/icons";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function EvaluatePropertyStatus({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }

  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="blue-info-text">
              Make sure property is vacant or has a pending move out - view the
              property page and tenant page in appfolio to verify.
            </h3>
          </Col>
          <Col span={24}>
            <Form.Item label="Tenant Name" name="tenantName">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Property Address" name="propertyAddress">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Move out date" name="moveOutDate">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item
              label="Users email - property manager"
              name="managerEmail"
            >
              <Input placeholder="Type Answer Here" prefix={<MailOutlined />} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default EvaluatePropertyStatus;
